// extracted by mini-css-extract-plugin
module.exports = {"productInformation":"ProductInformation_productInformation__mkF8N","showFormButton":"ProductInformation_showFormButton__2X1i5"};